export interface AnimeItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  region: string;
  rating: number;
  episodes: string;
  status: string;
  year: string;
  tags: string[];
  description: string;
}

export const animeList: AnimeItem[] = [
  {
    id: "xinghai",
    title: "星海旅人",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20space%20adventure%20anime%20key%20visual%20of%20a%20young%20astronaut%20gazing%20at%20a%20glowing%20nebula%2C%20warm%20amber%20and%20coral%20palette%2C%20soft%20starlight%2C%20cinematic%20illustration&width=600&height=800&seq=anime-xinghai&orientation=portrait",
    category: "qihuan",
    region: "日漫",
    rating: 9.2,
    episodes: "24",
    status: "连载",
    year: "2026",
    tags: ["科幻", "冒险", "成长"],
    description: "少年与迷路的外星同伴踏上横跨银河的旅程，在星辰之间寻找家园与答案。",
  },
  {
    id: "yunduan",
    title: "云端剑客",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20chinese%20wuxia%20anime%20key%20visual%20of%20a%20swordsman%20standing%20on%20a%20floating%20mountain%20peak%2C%20ink%20wash%20clouds%2C%20warm%20vermilion%20and%20gold%20palette%2C%20epic%20atmosphere&width=600&height=800&seq=anime-yunduan&orientation=portrait",
    category: "guoman",
    region: "国漫",
    rating: 9.5,
    episodes: "36",
    status: "连载",
    year: "2025",
    tags: ["武侠", "国漫", "江湖"],
    description: "江湖少年拔剑问天，以云海为疆场，守护故土与心中侠义。",
  },
  {
    id: "yinghua",
    title: "樱花便利店",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20romance%20anime%20key%20visual%20of%20a%20clerk%20and%20customer%20by%20a%20warm%20storefront%20at%20dusk%2C%20cherry%20blossom%20petals%2C%20soft%20pink%20and%20amber%20palette%2C%20cozy%20atmosphere&width=600&height=800&seq=anime-yinghua&orientation=portrait",
    category: "lianai",
    region: "日漫",
    rating: 8.9,
    episodes: "12",
    status: "完结",
    year: "2024",
    tags: ["恋爱", "治愈", "日常"],
    description: "深夜便利店的每一次相遇，都在悄悄改变两个人的平凡生活。",
  },
  {
    id: "bangqiu",
    title: "热血棒球少年",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20sports%20anime%20key%20visual%20of%20a%20baseball%20pitcher%20in%20full%20motion%20with%20dust%20and%20sunlight%2C%20warm%20orange%20and%20amber%20palette%2C%20dynamic%20action%2C%20energetic%20stadium%20background&width=600&height=800&seq=anime-bangqiu&orientation=portrait",
    category: "yundong",
    region: "日漫",
    rating: 9.0,
    episodes: "52",
    status: "连载",
    year: "2025",
    tags: ["运动", "热血", "青春"],
    description: "天赋平平的少年用汗水与坚持，在家乡球场上投出属于他的逆袭一球。",
  },
  {
    id: "shanhai",
    title: "山海异闻录",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20mythical%20beasts%20anime%20key%20visual%20of%20a%20guardian%20and%20a%20glowing%20spirit%20creature%20in%20misty%20mountains%2C%20ink%20wash%20and%20gold%20palette%2C%20warm%20tonal%20lighting%2C%20mystical%20atmosphere&width=600&height=800&seq=anime-shanhai&orientation=portrait",
    category: "guoman",
    region: "国漫",
    rating: 9.4,
    episodes: "40",
    status: "连载",
    year: "2024",
    tags: ["志怪", "国漫", "奇幻"],
    description: "少年护送一只传说神兽穿越山海，一路揭开了上古异闻背后的秘密。",
  },
  {
    id: "jiaji",
    title: "机甲纪元",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20mecha%20anime%20key%20visual%20of%20a%20pilot%20inside%20a%20gigantic%20robot%20under%20an%20orange%20dusk%20sky%2C%20warm%20steel%20and%20coral%20palette%2C%20epic%20scale%2C%20cinematic%20composition&width=600&height=800&seq=anime-jiaji&orientation=portrait",
    category: "qihuan",
    region: "日漫",
    rating: 9.1,
    episodes: "26",
    status: "完结",
    year: "2023",
    tags: ["科幻", "机甲", "战争"],
    description: "末日废土上，少年驾驶最强机甲直面崩塌的文明与消失的过去。",
  },
  {
    id: "tiangong",
    title: "甜品工坊",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20food%20anime%20key%20visual%20of%20a%20chef%20presenting%20colorful%20desserts%20in%20a%20warm%20kitchen%2C%20soft%20cream%20and%20amber%20palette%2C%20appetizing%20details%2C%20cozy%20studio%20lighting&width=600&height=800&seq=anime-tiangong&orientation=portrait",
    category: "zhiyu",
    region: "日漫",
    rating: 8.8,
    episodes: "24",
    status: "连载",
    year: "2026",
    tags: ["美食", "治愈", "日常"],
    description: "小镇甜品铺里的每一道点心，都藏着一段温暖的故事与愿望。",
  },
  {
    id: "gudu",
    title: "古都秘影",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20mystery%20anime%20key%20visual%20of%20a%20detective%20under%20ancient%20lanterns%20in%20an%20old%20city%20alley%20at%20night%2C%20deep%20maroon%20and%20amber%20palette%2C%20shadowy%20moody%20atmosphere&width=600&height=800&seq=anime-gudu&orientation=portrait",
    category: "xuanyi",
    region: "国漫",
    rating: 8.9,
    episodes: "18",
    status: "完结",
    year: "2024",
    tags: ["悬疑", "国漫", "推理"],
    description: "尘封古都接连出现离奇事件，年轻捕快与神秘客携手追查真相。",
  },
  {
    id: "maoer",
    title: "猫耳侦探社",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20comedy%20mystery%20anime%20key%20visual%20of%20a%20cheerful%20cat-eared%20detective%20team%20in%20a%20colorful%20office%2C%20bright%20yellow%20and%20coral%20palette%2C%20playful%20flat%20illustration&width=600&height=800&seq=anime-maoer&orientation=portrait",
    category: "gaoxiao",
    region: "日漫",
    rating: 8.6,
    episodes: "20",
    status: "连载",
    year: "2025",
    tags: ["搞笑", "悬疑", "日常"],
    description: "一群猫耳侦探一边摸鱼一边破案，用最离谱的方式解决最诡异的案子。",
  },
  {
    id: "luori",
    title: "落日篮球部",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20basketball%20anime%20key%20visual%20of%20a%20team%20huddled%20under%20golden%20sunset%20court%20lights%2C%20warm%20orange%20and%20amber%20palette%2C%20emotional%20teamwork%20moment%2C%20cinematic%20composition&width=600&height=800&seq=anime-luori&orientation=portrait",
    category: "yundong",
    region: "日漫",
    rating: 9.3,
    episodes: "30",
    status: "连载",
    year: "2025",
    tags: ["运动", "热血", "青春"],
    description: "濒临解散的篮球部在最后一季迎来转机，用团结重新点燃赛场。",
  },
  {
    id: "shenchu",
    title: "神厨小当家",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20cooking%20anime%20key%20visual%20of%20a%20young%20chef%20with%20steaming%20wok%20and%20golden%20light%2C%20warm%20cream%20and%20amber%20palette%2C%20appetizing%20food%20details%2C%20cozy%20chinese%20kitchen&width=600&height=800&seq=anime-shenchu&orientation=portrait",
    category: "guoman",
    region: "国漫",
    rating: 9.0,
    episodes: "44",
    status: "连载",
    year: "2023",
    tags: ["美食", "国漫", "热血"],
    description: "少年用一把炒勺游走江湖，以厨艺对决守住家传的滋味与初心。",
  },
  {
    id: "shikong",
    title: "时空邮局",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20time%20fantasy%20anime%20key%20visual%20of%20a%20postal%20worker%20holding%20a%20glowing%20letter%20before%20a%20clockwork%20portal%2C%20warm%20gold%20and%20coral%20palette%2C%20whimsical%20atmosphere&width=600&height=800&seq=anime-shikong&orientation=portrait",
    category: "qihuan",
    region: "日漫",
    rating: 8.7,
    episodes: "16",
    status: "完结",
    year: "2024",
    tags: ["奇幻", "治愈", "穿越"],
    description: "一间跨时空的邮局，替无法相见的人们投递寄往过去或未来的信。",
  },
];

export const featuredAnime = animeList.slice(0, 4);
export const hotAnime = [...animeList].sort((a, b) => b.rating - a.rating);
export const newAnime = animeList.filter((a) => a.year === "2026");